// 数据格式化
// 时间格式化 YYYY-mm-dd HH:MM
import moment from "moment";
import {ref} from "vue";

const dateFormat = (fmt, date) => {
  let ret;
  let opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }

  }

  return fmt;
}

// 时间加减天数  0-增加 1-减
const dateChange = (type, day, num) => {
  if (type === 0) {
    const date = moment(day).add(num, 'days')
    return date.format('YYYY-MM-DD')
  } else {
    const date = moment(day).subtract(num, 'days')
    return date.format('YYYY-MM-DD')
  }
}

const formatDate = (date, format) => {
  return moment(date).format(format)
}

const toDate = (date) => {
  return moment(date)
}


export default {
  dateFormat,
  dateChange,
  formatDate,
  toDate
}



// WEBPACK FOOTER //
// ./src/util/dataFormat.js